<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-rows">
  <form [formGroup]="technicalResourcesForm" *ngIf="!isLoading" class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 subsection">
      <p-table
        #technicalResourcesTable
        id="technical-resources"
        [value]="technicalResourcesForm?.value?.technicalResources"
        [scrollHeight]="'150px'"
        [rowTrackBy]="rowTrackByFunction">
        <!-- HEADER -->
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%">{{ 'regep.eeg-energy-producers.technical-resource' | translate }}</th>
            <th>{{ 'regep.eeg-energy-producers.energy-producer-id' | translate }}</th>
            <th *ngIf="isEdit">{{ 'regep.eeg-energy-producers.master-id' | translate }}</th>
          </tr>
        </ng-template>

        <!-- BODY -->
        <ng-template pTemplate="body" let-resource let-i="rowIndex" formArrayName="technicalResources">
          <tr [formGroupName]="i">
            <td style="width: 20%">#{{ i + 1 }}</td>
            <td>
              <ng-container *ngIf="eegProducerIdControlType == 'input'">{{ resource.energy_producer_id }}</ng-container>
              <ng-container *ngIf="eegProducerIdControlType == 'text'">
                <input
                  class="ui-input pInputText energy_producer_id required"
                  pInputText
                  name="energy_producer_id"
                  formControlName="energy_producer_id"
                  [attr.disabled]="disableEegProducerId"
                  type="text"
                  width="100%" />
              </ng-container>
              <div
                *ngIf="i >= 1 && !isReadOnly && !isEdit && isLastTechnicalResource(i) && isTechnicalResourceNotSaved(i)"
                (click)="deleteTechnicalResource(i)"
                class="pi pi-trash delete-id-btn"></div>
            </td>
            <td *ngIf="isEdit">
              <input
                class="ui-input pInputText full-width"
                pInputText
                [name]="'master_id_' + i"
                (change)="technicalResourceUpdated($event, i)"
                [attr.disabled]="isReadOnly == true ? true : null"
                formControlName="master_id" />
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">{{ 'overview.no-data-available' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div *ngIf="!isReadOnly && !isEdit" class="ui-g-12 field-rows subsection plus-btn">
      <i (click)="addTechnicalResource()" class="pi pi-plus plus-icon" data-testId="add-technical-resource" tabindex="0" appEnterClick></i>
      <label class="ui-g-5 field-label">{{ 'regep.eeg-energy-producers.add-technical-resource' | translate }}</label>
    </div>
  </form>
  <div
    *ngIf="showEnergyProducerIdInfoText"
    class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 subsection"
    innerHtml="{{ 'regep.eeg-energy-producers.info-text' | translate }}"></div>
  <div *ngIf="!isReadOnly && !isEdit && orderProcess && technicalResourcesForm" class="ui-g-12 submit-button-section">
    <button
      (click)="saveEnergyProducerIds(orderProcess)"
      [disabled]="technicalResourcesForm.invalid || technicalResourcesForm.pristine"
      label="{{ 'regep.eeg-energy-producers.save-energy-producer-ids' | translate }}"
      pButton
      type="button"></button>
  </div>
</div>
